import React from 'react';
import { DividerContainer, InnerDivider } from './styles';

export const VerticalDivider = () => {
  return (
    <DividerContainer>
      <InnerDivider />
    </DividerContainer>
  );
};

VerticalDivider.displayName = 'VerticalDivider';
